'use client';

import { usePathname } from '@/i18n/routing';
import { DecorBackground } from './DecorBackground';

export function ArtistProgramDecor() {
  const pathname = usePathname();
  if (pathname === '/artist-program') return null;
  return <DecorBackground />;
}
